import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Avatar } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { get, status } from "../../api/User"

/* Widgets */
import { toast } from "../common"

/* Shared */
import { KINDS, BOOKING_STATUSES, stateOf, channelOf, ago, initialsOf, avatarColorOf, digitsOf } from "./shared"
import { organizationIcon } from "../organization/shared"
import { plural } from "../category/shared"
import { money } from "../service/shared"

/* Constants */
import { env } from "../../constants"

/* Moment */
import moment from "moment"

Modal.setAppElement("#root")


/* Widget User Modal — the whole card of one client: who it is, how much it books, where from,
   where to and what it thinks. It is opened by the reference: this._user.current.open(item) */
class UserModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",
            data: null,

            /* The preview of the line of the list — the header is drawn while the card loads */
            item: null,

            /* The form of the blocking */
            blocking: false,
            reason: "",
            waiting: false
        }
    }

    open = item => {
        this.setState({ visible: true, item, status: "loading", data: null, blocking: false, reason: "", waiting: false }, () => this.load())
    }

    close = () => {

        if (this.state.waiting) {
            return
        }

        this.setState({ visible: false })
    }

    load = () => {

        const { item } = this.state

        get({ id: item.id }).then(response => {
            if (response && response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => this.setState({ status: "error" }))
    }

    /* Copy the phone — the hand goes to WhatsApp or a call right after */
    copy = text => {

        if (!navigator.clipboard) {
            return
        }

        navigator.clipboard.writeText(text).then(() => toast.success("Скопировано")).catch(() => { })
    }

    /* Block the account or bring it back */
    change = active => {

        /* Fields */
        const { data, reason, waiting } = this.state
        const { onChanged } = this.props

        if (waiting) {
            return
        }

        this.setState({ waiting: true })

        status({ id: data.user.id, active, reason: reason.trim() }).then(response => {

            this.setState({ waiting: false })

            if (response && response.status === 200) {
                toast.success(active ? "Аккаунт восстановлен" : "Аккаунт заблокирован")
                this.setState({ blocking: false, reason: "" })
                this.load()
                onChanged()
            }
            else {
                toast.error("Что-то пошло не так! Попробуйте позднее")
            }
        }).catch(() => {
            this.setState({ waiting: false })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    /* The top of the card — the photo, the name and the ways to reach the client */
    _hero = () => {

        /* Fields */
        const { item, data } = this.state

        const user = data ? data.user : item
        const kind = KINDS[user.kind] ? KINDS[user.kind] : KINDS.lead
        const state = stateOf(user)
        const phone = digitsOf(user.phone)
        const image = user.image ? `${env.mediapoint}users/${user.image}` : null

        let birthday = null

        if (user.birth) {
            const birth = moment(user.birth)
            const next = moment(birth).year(moment().year())
            const days = next.startOf("day").diff(moment().startOf("day"), "days")
            birthday = { date: birth.format("D MMMM"), age: moment().diff(birth, "years"), soon: days >= 0 && days <= 7 }
        }

        return (
            <div className={`user-hero ${state.key}`} style={{ "--avatar": avatarColorOf(user.id) }}>

                <Avatar className="user-hero-avatar" src={image} alt={user.name}>
                    {user.name && `${user.name}`.trim().length > 0 ? <span>{initialsOf(user.name)}</span> : <Icon name="user" size={38} width={1.8} />}
                </Avatar>

                <div className="user-hero-text">

                    <div className="user-hero-name">{user.name && `${user.name}`.trim().length > 0 ? `${user.name}`.trim() : "Без имени"}</div>

                    <div className="user-hero-badges">
                        <div className={`user-badge ${kind.accent}`} title={kind.hint}><Icon name={kind.icon} size={12} width={2.2} />{kind.text}</div>
                        <div className={`user-badge ${state.accent}`}><i />{state.text}</div>
                        {birthday && <div className={`user-badge ${birthday.soon ? "pink" : "grey"}`}>🎂 {birthday.date}, {birthday.age} {plural(birthday.age, "год", "года", "лет")}</div>}
                    </div>

                    <div className="user-hero-contacts">

                        {user.phone &&
                            <div onClick={() => this.copy(user.phone)} className="user-contact" title="Скопировать">
                                <Icon name="otp" size={14} width={2} />
                                {user.phone}
                            </div>
                        }

                        {phone.length >= 10 &&
                            <a href={`https://wa.me/${phone}`} target="_blank" rel="noreferrer" className="user-contact whatsapp" title="Написать в WhatsApp">
                                <Icon name="support" size={14} width={2} />
                                WhatsApp
                            </a>
                        }

                        {phone.length >= 10 &&
                            <a href={`tel:+${phone}`} className="user-contact" title="Позвонить">
                                <Icon name="power" size={14} width={2} />
                                Позвонить
                            </a>
                        }

                        {user.email &&
                            <a href={`mailto:${user.email}`} className="user-contact" title="Написать на почту">
                                <Icon name="notification" size={14} width={2} />
                                {user.email}
                            </a>
                        }

                    </div>

                </div>

            </div>
        )
    }

    /* The account was switched off — when, by whom and why */
    _deactivated = () => {

        /* Fields */
        const { data } = this.state

        const user = data.user
        const state = stateOf(user)

        if (state.key === "active") {
            return null
        }

        return (
            <div className={`user-notice ${state.key}`}>
                <Icon name={state.key === "blocked" ? "power" : "trash"} size={18} width={2} />
                <div>
                    <b>{state.key === "blocked" ? "Аккаунт заблокирован" : "Аккаунт удалён клиентом"}{user.deactivatedAt ? ` ${moment(user.deactivatedAt).format("D MMMM YYYY, HH:mm")}` : ""}</b>
                    <span>
                        {state.key === "blocked"
                            ? (user.deactivationReason ? `Причина: ${user.deactivationReason}` : "Причина не указана")
                            : "Данные сохранены. Войти по этому номеру нельзя, пока аккаунт не восстановят"
                        }
                    </span>
                </div>
            </div>
        )
    }

    /* The numbers of the client */
    _metrics = () => {

        /* Fields */
        const { data } = this.state

        const totals = data.totals
        const missed = totals.cancelled + totals.missed
        const share = totals.bookings > 0 ? Math.round(missed / totals.bookings * 100) : 0

        const since = totals.firstBooking && moment(totals.firstBooking).isBefore(moment(data.user.createdAt)) ? totals.firstBooking : data.user.createdAt

        const cards = [
            { value: totals.bookings, text: plural(totals.bookings, "запись", "записи", "записей"), accent: "blue" },
            { value: totals.completed, text: "состоялись", accent: "green" },
            { value: money(totals.spent), text: "оплачено", accent: "violet" },
            { value: `${share}%`, text: `отмены и неявки · ${missed}`, accent: share >= 30 ? "red" : "grey" }
        ]

        return (
            <div className="user-section">

                <div className="user-metrics">
                    {cards.map(card =>
                        <div className={`user-metric ${card.accent}`} key={card.text}>
                            <b>{card.value}</b>
                            <span>{card.text}</span>
                        </div>
                    )}
                </div>

                <div className="user-facts">
                    <div><span>Клиент с</span><b>{moment(since).format("D MMMM YYYY")}</b></div>
                    <div><span>Последний визит</span><b>{totals.lastVisit ? `${moment(totals.lastVisit).format("D MMM YYYY")} · ${ago(totals.lastVisit)}` : "—"}</b></div>
                    <div><span>Впереди</span><b>{totals.upcoming > 0 ? `${totals.upcoming} ${plural(totals.upcoming, "запись", "записи", "записей")}` : "нет записей"}</b></div>
                </div>

            </div>
        )
    }

    /* Where the client books from — one bar split by the channels */
    _channels = () => {

        /* Fields */
        const { data } = this.state

        const channels = data.channels

        if (channels.length === 0) {
            return null
        }

        const total = channels.reduce((sum, item) => sum + item.count, 0)
        const first = [...channels].sort((one, two) => moment(one.first).diff(moment(two.first)))[0]

        return (
            <div className="user-section">

                <div className="user-section-title">
                    Откуда записывается
                    <span>первая запись — «{channelOf(first.channel).text}»</span>
                </div>

                <div className="user-channels-bar">
                    {channels.map(item =>
                        <i key={item.channel} style={{ flex: item.count, background: channelOf(item.channel).color }} title={`${channelOf(item.channel).text}: ${item.count}`} />
                    )}
                </div>

                <div className="user-channels">
                    {channels.map(item => {

                        const channel = channelOf(item.channel)

                        return (
                            <div className="user-channel" key={item.channel} style={{ "--channel": channel.color }}>
                                <div className="user-channel-icon"><Icon name={channel.icon} size={14} width={2} /></div>
                                <div className="user-channel-text">
                                    <b>{channel.text}</b>
                                    <span>{item.count} · {Math.round(item.count / total * 100)}%</span>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    /* The points the client goes to */
    _organizations = () => {

        /* Fields */
        const { data } = this.state

        if (data.organizations.length === 0) {
            return null
        }

        const top = data.organizations[0].bookings

        return (
            <div className="user-section">

                <div className="user-section-title">Любимые точки</div>

                <div className="user-points">
                    {data.organizations.map(item =>
                        <div className="user-point" key={`${item.id}`}>
                            <Avatar className="user-point-avatar" src={item.image ? `${env.mediapoint}organizations/${item.image}` : null} alt={item.name}>
                                {organizationIcon()}
                            </Avatar>
                            <div className="user-point-text">
                                <b>{item.name}{item.favourite && <em title="В избранном">♥</em>}</b>
                                <div className="user-point-bar"><i style={{ width: `${Math.max(8, item.bookings / top * 100)}%` }} /></div>
                            </div>
                            <div className="user-point-count">
                                <b>{item.bookings}</b>
                                <span>{ago(item.lastVisit)}</span>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* The last visits */
    _bookings = () => {

        /* Fields */
        const { data } = this.state

        if (data.bookings.length === 0) {
            return (
                <div className="user-section">
                    <div className="user-section-title">Записи</div>
                    <div className="user-empty">Записей пока нет</div>
                </div>
            )
        }

        return (
            <div className="user-section">

                <div className="user-section-title">
                    Последние записи
                    {data.totals.bookings > data.bookings.length && <span>{data.bookings.length} из {data.totals.bookings}</span>}
                </div>

                <div className="user-timeline">
                    {data.bookings.map(item => {

                        const state = BOOKING_STATUSES[item.status] ? BOOKING_STATUSES[item.status] : BOOKING_STATUSES[0]
                        const channel = channelOf(item.channel)
                        const date = moment(item.reservedTime)

                        return (
                            <div className={`user-booking ${state.accent}`} key={`${item.id}`}>

                                <div className="user-booking-date">
                                    <b>{date.format("D")}</b>
                                    <span>{date.format("MMM YY")}</span>
                                </div>

                                <div className="user-booking-body">
                                    <div className="user-booking-title">
                                        {item.organization ? item.organization : "Точка удалена"}
                                        <div className={`user-booking-status ${state.accent}`}>{state.text}</div>
                                    </div>
                                    <div className="user-booking-services">{item.services ? item.services : "Услуга не указана"}</div>
                                    <div className="user-booking-meta">
                                        <span>{date.format("HH:mm")}</span>
                                        {item.member && <span>{item.member}</span>}
                                        <span className="channel" style={{ "--channel": channel.color }}><i />{channel.text}</span>
                                    </div>
                                </div>

                                <div className="user-booking-price">{money(item.price)}</div>

                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    /* The reviews of the client */
    _reviews = () => {

        /* Fields */
        const { data } = this.state

        if (data.reviews.length === 0) {
            return null
        }

        return (
            <div className="user-section">

                <div className="user-section-title">Отзывы<span>{data.extra.reviews}</span></div>

                <div className="user-reviews">
                    {data.reviews.map(item =>
                        <div className="user-review" key={`${item.id}`}>
                            <div className="user-review-head">
                                <div className="user-review-stars">
                                    {[1, 2, 3, 4, 5].map(star => <i key={star} className={star <= parseInt(item.rate) ? "on" : ""}>★</i>)}
                                </div>
                                <b>{item.organization}</b>
                                <span>{ago(item.createdAt)}</span>
                            </div>
                            {item.comment && <p>{item.comment}</p>}
                            {item.member && <div className="user-review-member">Мастер: {item.member}</div>}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Everything else the platform knows */
    _extra = () => {

        /* Fields */
        const { data } = this.state

        const extra = data.extra
        const user = data.user

        const facts = [
            { icon: "notification", text: "Push", value: extra.devices > 0 ? (parseInt(user.notify) === 1 ? "Включены" : "Выключены в профиле") : "Нет устройства", on: extra.devices > 0 && parseInt(user.notify) === 1 },
            { icon: "eye", text: "Уведомления", value: extra.notifications > 0 ? `открыто ${extra.opened} из ${extra.notifications}` : "нет" },
            { icon: "review", text: "Избранное", value: `${extra.favourites} ${plural(extra.favourites, "точка", "точки", "точек")}` },
            { icon: "queue", text: "Очередь", value: extra.queue > 0 ? `${extra.queue} ${plural(extra.queue, "раз", "раза", "раз")}` : "нет" },
            { icon: "support", text: "Поддержка", value: extra.supports > 0 ? `${extra.supports} ${plural(extra.supports, "обращение", "обращения", "обращений")}` : "нет" },
            { icon: "calendar", text: "Аккаунт создан", value: moment(user.createdAt).format("D MMM YYYY") }
        ]

        return (
            <div className="user-section">
                <div className="user-section-title">Ещё о клиенте</div>
                <div className="user-extra">
                    {facts.map(fact =>
                        <div className={`user-extra-item ${fact.on ? "on" : ""}`} key={fact.text}>
                            <Icon name={fact.icon} size={16} width={2} />
                            <div>
                                <span>{fact.text}</span>
                                <b>{fact.value}</b>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    /* The actions of the account */
    _actions = () => {

        /* Fields */
        const { data, blocking, reason, waiting } = this.state

        const state = stateOf(data.user)

        if (state.key !== "active") {
            return (
                <div className="user-actions">
                    <div onClick={() => this.change(1)} className={`organization-details-button ${waiting ? "disabled" : ""}`}>
                        {waiting ? <LoadingOutlined /> : "Восстановить аккаунт"}
                    </div>
                </div>
            )
        }

        if (blocking) {
            return (
                <div className="user-actions block">
                    <div className="user-actions-title">Заблокировать аккаунт?</div>
                    <div className="user-actions-hint">Клиент не сможет войти по коду и перестанет получать push. Записи, отзывы и история останутся — аккаунт можно восстановить.</div>
                    <textarea autoFocus maxLength={500} placeholder="Причина — увидят только администраторы" value={reason} onChange={event => this.setState({ reason: event.target.value })} />
                    <div className="user-actions-buttons">
                        <div onClick={() => this.setState({ blocking: false, reason: "" })} className="groups-modal-remove-button light">Отмена</div>
                        <div onClick={() => this.change(0)} className={`groups-modal-remove-button danger ${waiting ? "disabled" : ""}`}>
                            {waiting ? <LoadingOutlined /> : "Заблокировать"}
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="user-actions">
                <div onClick={() => this.setState({ blocking: true })} className="user-block-link">
                    <Icon name="power" size={15} width={2} />
                    Заблокировать аккаунт
                </div>
            </div>
        )
    }

    _body = () => {

        /* Fields */
        const { status } = this.state

        if (status === "loading") {
            return <div className="wide-modal-loading"><LoadingOutlined /></div>
        }

        if (status !== "ok") {
            return (
                <div className="wide-modal-loading">
                    <Icon name="alert" size={38} width={1.5} />
                    <p>Не удалось загрузить клиента</p>
                </div>
            )
        }

        return (
            <>
                {this._deactivated()}
                {this._metrics()}
                {this._channels()}
                {this._organizations()}
                {this._bookings()}
                {this._reviews()}
                {this._extra()}
                {this._actions()}
            </>
        )
    }

    render = () => {

        /* Fields */
        const { visible, item } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal large user-modal"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>Клиент</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {item &&
                    <div className="wide-modal-body">
                        {this._hero()}
                        {this._body()}
                    </div>
                }

            </Modal>
        )
    }
}

export default UserModal
